import { makeStyles } from '@material-ui/core/styles';

import { STEP_WIDTH } from '../Stepper.styles';

import { StepConnectorStyleProps } from './StepConnector.types';

export const useStyles = makeStyles(theme => {
  const stepWidth = theme.spacing(STEP_WIDTH);
  const itemSpace = theme.spacing(0.3 * STEP_WIDTH);
  const spaceBetweenSteps = (numberOfSteps: number) => `(100% - ${numberOfSteps * stepWidth}px) / ${numberOfSteps - 1}`;
  return {
    container: {
      top: theme.spacing(1.2),
      left: ({ numberOfSteps, currentIndex }: StepConnectorStyleProps) =>
        `calc(${stepWidth}px * ${currentIndex} + ${spaceBetweenSteps(numberOfSteps)} * ${
          currentIndex - 1
        } - ${itemSpace}px)`,
      width: ({ numberOfSteps }: StepConnectorStyleProps) =>
        `calc( ${spaceBetweenSteps(numberOfSteps)} + ${1.9 * itemSpace}px)`,
      position: 'absolute',
      height: theme.spacing(0.25),
    },
    svg: {
      width: '100%',
      height: theme.spacing(0.25),
      position: 'absolute',
      '& line': {
        stroke: ({ activeStep, currentIndex }: StepConnectorStyleProps) =>
          activeStep >= currentIndex ? theme.palette.primary.main : theme.palette.black.light,
      },
    },
  };
});
